import { render } from "./SkiLogDetail.vue?vue&type=template&id=37da0025&scoped=true"
import script from "./SkiLogDetail.vue?vue&type=script&lang=js"
export * from "./SkiLogDetail.vue?vue&type=script&lang=js"

import "./SkiLogDetail.vue?vue&type=style&index=0&id=37da0025&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37da0025"]])

export default __exports__